<template>
  <div class="notifications-button-wrapper close-notifications-button-wrapper">
    <badge v-if="unreadNotificationCount > 0"
           class="notifications-button__badge close-notifications-button__badge"
           colour="secondary"
           text-colour="white"
           size="small">
      {{ unreadNotificationCount }}
    </badge>
    <close-button @click="close" colour="grey"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseButton from '@/components/Buttons/CloseButton'
import Badge from '../Badge'

export default {
  name: 'CloseNotificationsModalButton',
  components: { Badge, CloseButton },
  computed: {
    ...mapGetters(
      {
        unreadNotificationCount: 'notifications/unreadNotificationCount',
      },
    ),
  },
  methods: {
    ...mapActions(
      {
        close: 'localModal/close',
      },
    ),
  },
}
</script>
